import { WORKSPACE_ACTIONS } from 'src/constants/workspacesConstants';

export enum WORKSPACE_COL_IDS {
  NAME = 'name',
  CREATED = 'created_at',
  ACTIONS = 'actions'
}

export const TRUNCATE_NAME_WIDTH = 130;

export const titleByAction = {
  [WORKSPACE_ACTIONS.DELETE]: 'Delete workspace',
  [WORKSPACE_ACTIONS.CREATE_WORKSPACE]: 'New workspace',
  [WORKSPACE_ACTIONS.EDIT_WORKSPACE]: 'Edit workspace'
};
